import request from '@/utils/request'

// 访客登记
export function saveVisit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/visit.saveVisit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改访客信息
export function updateVisit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/visit.updateVisit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询访客列表（直接调用后端，不走物联网）
export function listVisits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/visit.listVisits',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
